import { Box, type SxProps } from '@mui/material';

type Props = {
  children: React.ReactNode;
  padding?: number;
  containerSx?: SxProps;
  dataTestId?: string;
};

export function ShadowContainer({ children, containerSx = {}, dataTestId }: Props) {
  return (
    <Box
      sx={{
        padding: 2, // Add padding to allow shadow to show (not clipped by overflow: hidden)
      }}
    >
      <Box
        {...(dataTestId && { 'data-testid': dataTestId })}
        sx={{
          boxShadow: '0 1px 4px 0 rgba(100, 102, 106, 0.36), 0 4px 8px 0 rgba(100, 102, 106, 0.10)',
          borderRadius: 2,
          ...containerSx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
